import { useShallow } from 'zustand/react/shallow';
import useGeneralSettingsStore from '../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { MediaFormatEnum } from '../../../../general-settings/enums/mediaFormat.enum';
import { getRectangularGalleryColumnWidth } from '../components/RectangularGallery/rectangularGallery.utils';
import {
  getSquareGalleryColumnWidth,
  getSquareStackColumnWidth,
} from '../components/SquareGallery/squareGallery.utils';
import { UseGalleryColumnWidthParams } from '../interfaces/productGallery.interfaces';

const CONTENT_COLUMN_MIN_WIDTH = 590;
const MEDIA_COLUMN_MIN_WIDTH = 200;
const MEDIA_COLUMN_MAX_SHARE = 0.45;

const getAvailableMediaWidth = (panelWidth: number) =>
  Math.max(
    MEDIA_COLUMN_MIN_WIDTH,
    Math.min(panelWidth * MEDIA_COLUMN_MAX_SHARE, panelWidth - CONTENT_COLUMN_MIN_WIDTH),
  );

const getSquareColumnWidth = ({ galleryHeight, panelWidth }: UseGalleryColumnWidthParams) => {
  const thumbGridWidth = getSquareGalleryColumnWidth(galleryHeight);

  if (!panelWidth || getAvailableMediaWidth(panelWidth) >= thumbGridWidth) {
    return thumbGridWidth;
  }

  return getSquareStackColumnWidth(galleryHeight);
};

const useGalleryColumnWidth = ({ galleryHeight, panelWidth }: UseGalleryColumnWidthParams) => {
  const { mediaFormat } = useGeneralSettingsStore(
    useShallow((state) => ({
      mediaFormat: state.generalSettings.mediaFormat,
    })),
  );

  if (mediaFormat === MediaFormatEnum.SQUARE) {
    return getSquareColumnWidth({ galleryHeight, panelWidth });
  }

  return getRectangularGalleryColumnWidth(galleryHeight);
};

export default useGalleryColumnWidth;
